import ClassicQuizLeaderboardMeta from "./ClassicQuizLeaderboardMeta";
import ClassicQuizRankModel from "./ClassicQuizRankModel";

export default class ClassicQuizzesLeaderboardModel {
  public meta: ClassicQuizLeaderboardMeta = new ClassicQuizLeaderboardMeta();
  public data: ClassicQuizRankModel[] = [];
}
